import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-test-centers',
  templateUrl: './test-centers.component.html',
  styleUrls: ['./test-centers.component.scss']
})
export class TestCentersComponent implements OnInit {


  @Input() data;
  @Input() header;
  @Output() dataChange = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onSelectItem(e) {
    this.data = e.item;
    this.dataChange.emit(this.data);
  }
};
